// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3dni_","buttons":"PendingPaymentAlert_buttons__2U-ud"};